/**
 * 判断是否已有策略 id（应走 /strategy/modify）。
 * 空串、空白、0、负数、NaN 视为新建（走 /strategy/save）。
 * 非空且无法解析为数字的字符串视为已有 id（兼容非数字 id）。
 */
export function hasExistingStrategyId (id: string | number | undefined | null): boolean {
  if (id === undefined || id === null) {
    return false
  }
  if (typeof id === 'number') {
    return Number.isFinite(id) && id > 0
  }
  const s = String(id).trim()
  if (s === '') {
    return false
  }
  const n = Number(s)
  if (Number.isFinite(n)) {
    return n > 0
  }
  return true
}
